import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HelpSectionComponent } from "./help-section.component";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
    declarations: [HelpSectionComponent],
    imports: [CommonModule, TranslateModule, MatButtonModule, MatIconModule],
    exports: [HelpSectionComponent]
})
export class HelpSectionModule {}
